import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox
} from "@fancyapps/ui";

import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

import Swiper from 'swiper/bundle';
exports.swiper = Swiper;

AOS.init({
	once: true,
	duration: 800, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out',
	initClassName: false,
	anchorPlacement: 'center-bottom'
});

Fancybox.bind("[data-fancybox]", {
	hideScrollbar: true,
});

jQuery(function ($) {
	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: cpceAjax.ajaxurl, // The WordPress AJAX handler
			data : formData,
			dataType : 'json',
			type: 'POST',
			beforeSend: function () {
				$('#cpce_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				cpceAjax.current_page = 1;
 
				// set the new query parameters
				cpceAjax.posts = data.posts;
 
				// set the new max page parameter
				cpceAjax.max_page = data.max_page;



				$('#cpce_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if ( data.max_page < 2 ) {
					$('#cpce_loadmore').hide();
				} else {
					$('#cpce_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#cpce_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#cpce_loadmore').click(function(){
 
		$.ajax({
			url : cpceAjax.ajaxurl, // AJAX handler
			data : {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': cpceAjax.posts, // loop parameters passed by wp_localize_script()
				'page' : cpceAjax.current_page // current page
			},
			type : 'POST',
			beforeSend : function ( xhr ) {
				$('#cpce_loadmore').text('Loading...'); // some type of preloader
			},
			success : function( posts ){
				if( posts ) {
 				//console.log(posts);
					$('#cpce_loadmore').text( 'More posts' );
					$('#cpce_posts_wrap').append( posts ); // insert new posts
					cpceAjax.current_page++;
 
					if ( cpceAjax.current_page == cpceAjax.max_page ) 
						$('#cpce_loadmore').hide(); // if last page, HIDE the button
 
				} else {
					$('#cpce_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});
});